// websocket
import SockJS from 'sockjs-client';
import { Stomp } from './stomp';
import { loadAllLocks } from '../../store/collaboration';
import { filterData } from '@/component/blogic/deals/store/search.store.js';
// import { tryToLogout } from '../session.store';
// import { ignoreFormChanged } from '../allaround.store';
// переехал в complex
import { tryToLogout } from '../session.store';
import { ignoreFormChanged } from '../allaround.store';
import { dicts } from '../SimpleDictsNames';

let stomp = undefined;
let ws = undefined;

export const closeWS = () => {
  if (stomp) {
    stomp.disconnect();
    stomp = undefined;
  }
  if (ws) {
    ws.close();
    ws = undefined;
  }
};

export const openWS = (store) => {
  // закрываем сокет, если был открыт
  closeWS();

  // получаем актуальный URL
  let URL = window.location.host;

  // если не в проде, то меняем порт,
  // т.к. webpack не дает нормально работать WS с оригинальным портом
  if (!(process.env && process.env.NODE_ENV == 'production')) {
    URL = URL.replace('9090', '8443');
  }

  // тут надо добавить магии для работы под webpack'ом
  ws = new SockJS(  `https://${URL}/notifications`);

  ws.disconnectCallback = () => {
    ignoreFormChanged(store.dispatch);
    console.log('WebSocket disconnected unexpectedly')
    if (store.getState().getIn(['session', 'state']) == 'LOGGED_IN') {
      console.log('Trying to reconnect');
      setTimeout(() => openWS(store), 1000);
    } else {
       tryToLogout(store.dispatch, false);
    }
  };

  ws.onopen = function onOpen() {
    stomp = Stomp.over(ws);

    stomp.debug = null;
    const csrf = store.getState().getIn(['session', 'csrf']);
    stomp.connect({ 'X-CSRF-TOKEN': csrf });

    // DEALS CRUD
    const deals = [
      'purchase',
      'sale',
      'transport',
    ];

    deals.forEach(deal => {
      stomp.subscribe(`/topic/create/${deal}`, (payload) => {
        store.dispatch({
          type: 'WS_RECEIVED_DEAL_CREATED',
          data: JSON.parse(payload.body),
          dealType: deal,
        });
        if (deal && deal != 'transport') {
          filterData(store.dispatch,
            store.getState().getIn(['search', deal, 'filters', 'myDeals']),
            store.getState().getIn(['search', deal, 'filters', 'ptypes'], new Set()),
            deal);
        }
      });
      stomp.subscribe(`/topic/update/${deal}`, (payload) => {
        store.dispatch({
          type: 'WS_RECEIVED_DEAL_UPDATED',
          data: JSON.parse(payload.body),
          dealType: deal,
        });
        if (deal && deal == 'transport') {
          store.dispatch({
            type: 'UPDATE_CURRENT_DEAL_TRANSPORT',
            data: JSON.parse(payload.body),
            dealType: deal,
          });
        }
      });
      /*
      // обновление текущей сделки третьим лицом
      stomp.subscribe(`/topic/update/current/${deal}`, (payload) => {
        const currentDeal = store.getState().getIn(['data', 'deals', 'deal'], new Map());
        const data = JSON.parse(payload.body);
        if (currentDeal.get('id') == data.id) {
          store.dispatch({
            type: 'DEAL_LOADED',
            data,
            dealType: deal,
          });
        }
      });
      */
      stomp.subscribe(`/topic/delete/${deal}`, (payload) => {
        store.dispatch({
          type: 'WS_RECEIVED_DEAL_DELETED',
          id: payload.body,
          dealType: deal,
        });
      });
    });

    // deal lock/unlock

    stomp.subscribe('/topic/locked/deal', (payload) => {
      store.dispatch({
        type: 'DEAL_LOCKED',
        currentUserId: store.getState().getIn(['session', 'id']),
        lock: JSON.parse(payload.body),
      });
    });
    stomp.subscribe('/topic/unlocked/deal', (payload) => {
      store.dispatch({
        type: 'DEAL_UNLOCKED',
        currentUserId: store.getState().getIn(['session', 'id']),
        lock: JSON.parse(payload.body),
      });
    });
    stomp.subscribe('/topic/notification', (payload) => {
      const notification = JSON.parse(payload.body);
      const currentUserId = store.getState().getIn(['session', 'id']);
      if (currentUserId == notification.user) {
        store.dispatch({
          type: 'WS_NOTIFICATION_RECEIVED',
          currentUserId,
          data: notification,
        });
      }
    });

    // SimpleDict CRUD


    dicts.forEach(dict => {
      stomp.subscribe(`/topic/create/${dict}`, (payload) => {
        store.dispatch({
          type: `${dict.toUpperCase()}_CREATED_SUCCESSFULLY`,
          data: JSON.parse(payload.body),
        });
      });
      stomp.subscribe(`/topic/update/${dict}`, (payload) => {
        store.dispatch({
          type: `${dict.toUpperCase()}_UPDATED_SUCCESSFULLY`,
          data: JSON.parse(payload.body),
        });
      });
      stomp.subscribe(`/topic/delete/${dict}`, (payload) => {
        store.dispatch({
          type: `${dict.toUpperCase()}_DELETED`,
          id: payload.body,
        });
      });
      stomp.subscribe(`/topic/restore/${dict}`, (payload) => {
        store.dispatch({
          type: `${dict.toUpperCase()}_RESTORED`,
          id: payload.body,
        });
      });
    });

    // ComplexDict CRUD
    // product
    stomp.subscribe('/topic/create/product', (payload) => {
      store.dispatch({
        type: 'PRODUCT_CREATED_SUCCESSFULLY',
        data: JSON.parse(payload.body),
      });
    });
    stomp.subscribe('/topic/update/product', (payload) => {
      const data = JSON.parse(payload.body);
      store.dispatch({
        type: 'PRODUCT_UPDATED_SUCCESSFULLY',
        data,
      });
    });
    stomp.subscribe('/topic/delete/product', (payload) => {
      store.dispatch({
        type: 'PRODUCT_DELETED',
        id: payload.body,
      });
    });
    stomp.subscribe('/topic/restore/product', (payload) => {
      store.dispatch({
        type: 'PRODUCT_RESTORED',
        id: payload.body,
      });
    });

    //  producttype
    stomp.subscribe('/topic/create/producttype', (payload) => {
      store.dispatch({
        type: 'PRODUCT_SUBTYPE_CREATED_SUCCESSFULLY',
        data: JSON.parse(payload.body),
      });
    });
    stomp.subscribe('/topic/update/producttype', (payload) => {
      const data = JSON.parse(payload.body);
      delete data.product;
      store.dispatch({
        type: 'PRODUCT_SUBTYPE_UPDATED_SUCCESSFULLY',
        data,
      });
    });
    stomp.subscribe('/topic/delete/producttype', (payload) => {
      store.dispatch({
        type: 'PRODUCT_SUBTYPE_DELETED',
        id: payload.body,
      });
    });
    stomp.subscribe('/topic/restore/producttype', (payload) => {
      store.dispatch({
        type: 'PRODUCT_SUBTYPE_RESTORED',
        id: payload.body,
      });
    });
    stomp.subscribe('/topic/create/payment', (payload) => {
      const data = JSON.parse(payload.body);
      store.dispatch({
        type: 'WS_PAYMENT_CREATED',
        data,
      });
    });
    stomp.subscribe('/topic/update/payment', (payload) => {
      const data = JSON.parse(payload.body);
      store.dispatch({
        type: 'WS_PAYMENT_UPDATED',
        data,
      });
    });
    stomp.subscribe('/topic/update/approval', (payload) => {
      const data = JSON.parse(payload.body);
      store.dispatch({
        type: 'WS_PAYMENT_TOP_APPROVED',
        data,
      });
    });
    stomp.subscribe('/topic/update/pricesdb', (payload) => {
      const isActive = JSON.parse(payload.body);
      store.dispatch({
        type: 'WS_PRICES_DATABASE_URL_PROCESSING_ACTION',
        isActive,
      });
    });
    stomp.subscribe('/topic/update/pricesdb/error', (payload) => {
      const error = payload.body;
      store.dispatch({
        type: 'WS_PRICES_DATABASE_ERROR',
        error,
      });
    });
    loadAllLocks(store.dispatch, store.getState().getIn(['session', 'id']));
  };
  ws.onclose = function onClose() {
    if (stomp) stomp.disconnect();
    stomp = undefined;
    ws = undefined;
  };
};
